import React from 'react';
import { HeroSection } from './home/HeroSection';
import { ServicesGridSection } from './home/ServicesGridSection';
import { AudienceSection } from './home/AudienceSection';
import { ProcessSection } from './home/ProcessSection';
import { PricingPreviewSection } from './home/PricingPreviewSection';
import { ComplexProjectsSection } from './home/ComplexProjectsSection';
import { FaqPreviewSection } from './home/FaqPreviewSection';
import { FinalCtaSection } from './home/FinalCtaSection';

const Home = () => (
  <div className="min-h-screen bg-[#fefdf4]">
    <HeroSection />
    <ServicesGridSection />
    <AudienceSection />
    <ProcessSection />
    <PricingPreviewSection />
    <ComplexProjectsSection />
    <FaqPreviewSection />
    <FinalCtaSection />
  </div>
);

export default Home;
